"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkmark = void 0;

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledTippy = _interopRequireDefault(require("../../StyledTippy"));

var _styles = require("./styles");

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "MarkRead__StyledButton",
  componentId: "sc-1412hn-0"
})(function (_ref) {
  var theme = _ref.theme;
  return (0, _deepExtend["default"])({}, (0, _styles.getStyles)(theme), {
    marginTop: -3
  }, theme.action);
});

var Checkmark = function Checkmark(_ref2) {
  var _ref2$fill = _ref2.fill,
      fill = _ref2$fill === void 0 ? "#566074" : _ref2$fill,
      style = _ref2.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    fill: "none",
    height: "24",
    style: style,
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.6825 8.2925C16.2925 7.9025 15.6625 7.9025 15.2725 8.2925L10.8425 12.7225C10.6425 12.9225 10.3325 12.9225 10.1325 12.7225L8.7025 11.2925C8.3125 10.9025 7.6825 10.9025 7.2925 11.2925C6.9025 11.6825 6.9025 12.3125 7.2925 12.7025L9.7825 15.2025C10.1725 15.5925 10.8025 15.5925 11.1925 15.2025L16.6825 9.7125C17.0725 9.3225 17.0725 8.6925 16.6825 8.3025V8.2925Z",
    fill: fill
  }));
};

exports.Checkmark = Checkmark;

var MarkRead = function MarkRead(_ref3) {
  var onClick = _ref3.onClick,
      label = _ref3.label;
  return /*#__PURE__*/_react["default"].createElement(_StyledTippy["default"], {
    content: label
  }, /*#__PURE__*/_react["default"].createElement(StyledButton, {
    title: label,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(Checkmark, null)));
};

var _default = MarkRead;
exports["default"] = _default;